"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineModeInterceptor = void 0;
const exception_1 = require("@almservices-cl/exception");
class OfflineModeInterceptor {
    constructor() {
        this.offline = false;
        this.goOffline = () => {
            this.offline = true;
        };
        this.goOnline = () => {
            this.offline = false;
        };
    }
    async intercept(request) {
        // @ts-ignore
        if (!this.offline ||
            (request.options !== undefined &&
                // @ts-ignore
                request.options.responseType === "arraybuffer")) {
            return request;
        }
        throw new exception_1.NetworkException("Request not permitted in offline mode");
    }
}
exports.OfflineModeInterceptor = OfflineModeInterceptor;
//# sourceMappingURL=OfflineModeInterceptor.js.map